<template>
  <div class="pt-4 lg:pb-14">
    <MSpinner class="loading-logo my-8 mx-auto" />
    <div class="h-32 w-4/5 relative mx-auto text-18 text-gray-500 text-center">
      <p
        v-for="(text, index) in textList"
        :key="index"
        class="w-full opacity-0 absolute transition duration-700"
        :class="paragraph === index ? 'opacity-100 translate-y-0' : 'translate-y-1/2'"
        v-text="text"
      />
    </div>
    <div
      class="max-w-2xl lg:max-w-4xl mx-auto flex flex-wrap gap-4 justify-center transition duration-700"
      :class="paragraph === -1 ? 'opacity-0 translate-y-1/4' : 'opacity-100 translate-y-0'"
    >
      <div
        v-for="provider in providers"
        :key="provider.name"
        class="w-36 h-12 p-2 lg:w-48 lg:h-16 lg:p-3 lg:px-5 rounded-6 shadow-2"
      >
        <img class="h-full mx-auto object-contain" :src="provider.logo" :alt="provider.name" />
      </div>
      <span
        class="flex justify-center items-center text-gray-400 font-semibold w-36 h-12 p-2 lg:w-48 lg:h-16 lg:text-18 rounded-6 shadow-2"
      >
        {{ $t('imt_loader.and_more') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
const SLIDE_TIMEOUT_1 = 500
const SLIDE_TIMEOUT_2 = 6000
const SLIDE_TIMEOUT_3 = 12000

const { $t } = useNuxtApp()

const paragraph = ref(-1)

const slideTimeouts: Array<ReturnType<typeof setTimeout>> = []

onMounted(() => {
  slideTimeouts.push(setTimeout(() => (paragraph.value = 0), SLIDE_TIMEOUT_1))
  slideTimeouts.push(setTimeout(() => (paragraph.value = 1), SLIDE_TIMEOUT_2))
  slideTimeouts.push(setTimeout(() => (paragraph.value = 2), SLIDE_TIMEOUT_3))
})

onBeforeUnmount(() => {
  slideTimeouts.forEach((id) => {
    clearTimeout(id)
  })
})

const textList = computed(() => {
  return [$t('imt_loader.comparing'), $t('imt_loader.fetching'), $t('imt_loader.longer')]
})

const providers = [
  {
    name: 'Wise',
    logo: 'https://monito.imgix.net/psp/wise-green-logo.png?w=400&auto=compress,format',
  },
  {
    name: 'Remitly',
    logo: 'https://monito.imgix.net/psp/remitly-new.png?w=400&auto=compress,format',
  },
  {
    name: 'WorldRemit',
    logo: 'https://monito.imgix.net/psp/worldremit-logo-oct2020.png?w=200&auto=compress,format',
  },
  {
    name: 'Small World',
    logo: 'https://monito.imgix.net/psp/small-world-money-transfer-blue.png?w=400&auto=compress,format',
  },
  {
    name: 'Western Union',
    logo: 'https://monito.imgix.net/psp/western-union-yellow-black.png?w=400&auto=compress,format',
  },
  {
    name: 'PayPal',
    logo: 'https://monito.imgix.net/psp/paypal-transparent-logo.png?w=400&auto=compress,format',
  },
]
</script>

<style scoped>
.loading-logo {
  background-image: url('@core/images/loading.svg');
  background-size: 40%;
}
</style>
